import { render, staticRenderFns } from "./ViewTag.vue?vue&type=template&id=5835056b&scoped=true&"
import script from "./ViewTag.vue?vue&type=script&lang=js&"
export * from "./ViewTag.vue?vue&type=script&lang=js&"
import style0 from "./ViewTag.vue?vue&type=style&index=0&id=5835056b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835056b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VContainer,VDivider})
